export default {
    getAccessToken : state => {
        return state.accessToken
    },
    isUserLoggedIn : state => {
        return state.isUserLoggedIn
    }
}